<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form" label-width="80px" size="mini">
        <div class="">
          <el-form-item label="年月:">
            <el-date-picker
              v-model="searchForm.yearMonthDate"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="请选择">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" class="allBtn" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" class="allBtn" @click="resetForm('searchForm')">重置</el-button>
            <el-button type="primary" class="allBtn" @click="addMaterial" v-if="btnFlg[1]">新增</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent" @selection-change="handleSelectionChange" @row-click="rowClick" highlight-current-row center border :span-method="objectSpanMethod">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="yearMonthDate" width="" label="年月"></el-table-column>
        <el-table-column prop="monthSubmitPlanDate" width="" label="月提交计划">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.monthSubmitPlanDate">
                <div >{{ dateFormat(scope.row.monthSubmitPlanDate) }}</div>
                <el-button v-if="scope.row.monthSubmitPlanDate && btnFlg[2]" type="text" size="mini" @click="updateMonthFn(scope.row)">修改</el-button>
              </div>
              <div v-else>-</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="150" label="操作">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="editWeekFn(scope.row)" v-if="btnFlg[2]">修改</el-button>
              <el-button type="text" size="mini" @click="delMaterial(scope.row)" v-if="scope.row.cycleName != '第1周' && btnFlg[3]">删除</el-button>
              <el-button type="text" size="mini" @click="addWeekFn(scope.row)" v-if="scope.row.cycleName == '第1周' && btnFlg[1]">新增</el-button>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="startMonth" width="" label="开始日期"></el-table-column>
        <el-table-column prop="endMonth" width="" label="结束日期"></el-table-column> -->
        <el-table-column prop="" width="190" label="计划周期">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.startMonth }} ~ {{ scope.row.endMonth }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="weekSubmitPlanDate" width="" label="周提交时间" :formatter="dateTimeFormat"></el-table-column>
        <el-table-column prop="cycleName" width="" label="周期别名"></el-table-column>
        <el-table-column prop="createUser" width="" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="" label="创建时间"></el-table-column>
        <el-table-column prop="updateUserName" width="" label="修改人" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="updateTime" width="" label="修改时间" :formatter="emptyFn"></el-table-column>
      </el-table>
    </div>
    <!-- 分页-->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.pageNo" :page-sizes="[10, 20, 25, 50, 100]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- 新增资金计划周期 -->
    <el-dialog title="新增资金计划" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="close" center width="500px">
      <el-form :rules="rules" :model="addForm" :validate-on-rule-change="false" ref="addForm" class="demo-form-inline" label-width="150px" :inline="false" size="small" v-if="dialogVisible">
        <div class="addinpBox">
          <el-form-item label="年月:" prop="yearMonthDate">
            <el-date-picker
              v-model="addForm.yearMonthDate"
              format="yyyy-MM"
              value-format="yyyy-MM"
              type="month"
              :picker-options="pickerOptions"
              placeholder="请选择">
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="saveFn" :loading="addLoading">保 存</el-button>
        <el-button @click="close" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 添加资金计划周期周数据 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogWeekVisible" @close="closeWeek" center width="500px">
      <el-form :rules="rules" :model="addWeekForm" :validate-on-rule-change="false" ref="addWeekForm" class="demo-form-inline" label-width="150px" :inline="false" size="small" v-if="dialogWeekVisible">
        <div class="addinpBox">
          <el-form-item label="开始日期:" prop="startMonth">
            <el-date-picker
              v-model="addWeekForm.startMonth"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              :picker-options="startDatePickerOptions"
              @change="onStartDateChange"
              placeholder="请选择">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期:" prop="endMonth">
            <el-date-picker
              v-model="addWeekForm.endMonth"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              :picker-options="editEndDatePickerOptions"
              placeholder="请选择">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="周期名称:" prop="cycleName">
            <!-- <el-input v-model.trim="addWeekForm.cycleName" placeholder="请输入" :disabled="!isAddWeek></el-input> -->
            <el-select v-model="addWeekForm.cycleName" placeholder="请选择" size="mini">
              <el-option label="第1周" value="第1周" ></el-option>
              <el-option label="第2周" value="第2周" ></el-option>
              <el-option label="第3周" value="第3周" ></el-option>
              <el-option label="第4周" value="第4周" ></el-option>
              <el-option label="第5周" value="第5周" ></el-option>
              <el-option label="第6周" value="第6周" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="周提交时间:" prop="weekSubmitPlanDate">
            <el-date-picker
              v-model="addWeekForm.weekSubmitPlanDate"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="请选择">
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="saveWeekFn">保 存</el-button>
        <el-button @click="closeWeek" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 修改月提交计划日期 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="updateMonthVisible" @close="closeUpdateMonth" center width="500px">
      <el-form :rules="rules" :model="updateMonthForm" :validate-on-rule-change="false" ref="updateMonthForm" class="demo-form-inline" label-width="150px" :inline="false" size="small" v-if="updateMonthVisible">
        <div class="addinpBox">
          <el-form-item label="月提交计划日期:" prop="monthSubmitPlanDate">
            <el-date-picker
              v-model="updateMonthForm.monthSubmitPlanDate"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="请选择">
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="saveUpdateMonthFn">保 存</el-button>
        <el-button @click="closeUpdateMonth" size="mini">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { findFundPlanCycleList, saveFundPlanCycle, saveFundPlanCycleWeek, updateFundPlanCycle, deleteFundPlanCycle, updateMonthSubmitPlan } from '@/api/common-signature'
import { dateFormat1, dateTimeFormat, emptyFn } from '@/utils/util'
export default {
  name: 'BasicMeterial',
  components: { },
  data () {
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      searchForm: {
        pageNo: 1,
        pageSize: 50
      },
      addForm: {},
      title: '',
      tableList: [],
      total: 0,
      dialogVisible: false,
      dialogWeekVisible: false,
      addWeekForm: {},
      rules: {
        yearMonthDate: [
          { required: true, message: '请选择年月', trigger: 'change' }
        ],
        startMonth: [
          { required: true, message: '请选择开始日期', trigger: 'change' }
        ],
        endMonth: [
          { required: true, message: '请选择结束日期', trigger: 'change' }
        ],
        cycleName: [
          { required: true, message: '请输入周期名称', trigger: 'change' }
        ],
        monthSubmitPlanDate: [
          { required: true, message: '请选择月提交计划日期', trigger: 'change' }
        ],
        weekSubmitPlanDate: [
          { required: true, message: '请选择周提交时间', trigger: 'change' }
        ]
      },
      addLoading: false,
      selectRows: [],
      selectRowsInfo: [],
      // 按钮
      btnFlg: [],
      btnIdArr: ['00FM0P0100', '00FM0P0200', '00FM0P0300', '00FM0P0400'],
      h: '',
      isAddWeek: false,
      updateMonthVisible: false,
      updateMonthForm: {},
      startDatePickerOptions: {
        disabledDate: () => false
      },
      // 修改时的日期限制规则，动态设置
      editEndDatePickerOptions: {
        disabledDate: (time) => {
          return false
        }
      },
      pickerOptions: {
        disabledDate (time) {
        // 获取当前日期
          const now = new Date()
          // 设置到当前月份的第一天（用于比较月份）
          const currentYear = now.getFullYear()
          const currentMonth = now.getMonth()
          const currentFirstDay = new Date(currentYear, currentMonth, 1)

          // 禁用今天之前的月份
          return time.getTime() < currentFirstDay.getTime()
        }
      },
      addEndDatePickerOptions: {
        disabledDate: (time) => {
        // 获取当前日期（设置为当天的开始时间）
          const now = new Date()
          now.setHours(0, 0, 0, 0)

          // 新增时只能选择当前日期之后的日期（不能选今天及之前的日期）
          return time.getTime() <= now.getTime()
        }
      }
    }
  },
  created () {
    this.findFundPlanCycleList()
  },
  mounted () {
    this.btnFlg = getBtn(this.btnIdArr, '/basicMaterial')
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 165 + 'px'
  },
  methods: {
    onStartDateChange (value) {
      // 当开始日期变化时，清空结束日期并更新结束日期的限制规则
      if (value && this.addWeekForm.yearMonthDate) {
        // 清空结束日期
        this.addWeekForm.endMonth = ''
        // 更新结束日期的限制规则
        this.updateEndDatePickerOptions(this.addWeekForm.yearMonthDate)
        // 强制更新视图
        this.$forceUpdate()
      }
    },
    findFundPlanCycleList () {
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      findFundPlanCycleList(this.searchForm)
        .then(res => {
          console.log(res)
          loading.close()
          this.tableList = res.list
          this.getSpanArr(this.tableList)
          this.total = res.total
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    // 合并单元格
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1 || columnIndex === 2) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    // 生成合并规则数组
    getSpanArr (data) {
      this.spanArr = []
      if (data.length === 0) return

      let pos = 0
      data.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1)
          pos = 0
        } else {
          // 根据 yearMonthDate 判断是否合并
          if (item.yearMonthDate === data[index - 1].yearMonthDate) {
            this.spanArr[pos] += 1
            this.spanArr.push(0) // 0表示该行被合并
          } else {
            this.spanArr.push(1)
            pos = index
          }
        }
      })
    },
    searchFn () {
      this.findFundPlanCycleList()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.findFundPlanCycleList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.findFundPlanCycleList()
    },
    rowClick (row, col, event) {
      this.selectRows[0] = row
      this.$refs.table.toggleRowSelection(row)
    },
    handleSelectionChange (val) {
      this.selectRows = val.map(item => item.id)
      this.selectRowsInfo = val
    },
    saveFn () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          saveFundPlanCycle(this.addForm)
            .then(res => {
              console.log(res)
              loading.close()
              this.dialogVisible = false
              this.findFundPlanCycleList()
              this.initAddForm()
              this.$message.success('添加成功')
            })
            .catch(err => {
              this.addLoading = false
              console.log(err)
              this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        } else {
          this.addLoading = false
        }
      })
    },
    resetForm () {
      this.searchForm.yearMonthDate = ''
      this.findFundPlanCycleList()
    },
    addMaterial () {
      this.dialogVisible = true
      this.addLoading = false
      this.$nextTick(() => {
        this.$refs['addForm'].clearValidate()
      })
    },
    initAddForm () {
      this.addForm = {}
      this.addWeekForm = {}
      this.updateMonthForm = {}
    },
    close () {
      this.dialogVisible = false
      this.initAddForm()
    },
    closeWeek () {
      this.dialogWeekVisible = false
      this.initAddForm()
      // 关闭弹窗时重置日期限制规则
      this.startDatePickerOptions = {
        disabledDate: () => false
      }
      this.editEndDatePickerOptions = {
        disabledDate: () => false
      }
    },
    delMaterial (row) {
      this.$confirm('是否执行删除操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteFundPlanCycle({
          cycleDetailId: row.cycleDetailId,
          cycleMasterId: row.cycleMasterId
        })
          .then(res => {
            loading.close()
            this.findFundPlanCycleList()
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      })
    },
    addWeekFn (row) {
      this.isAddWeek = true
      this.$set(this.addWeekForm, 'cycleMasterId', row.cycleMasterId)
      // 保存当前行的年月，用于日期限制
      this.$set(this.addWeekForm, 'yearMonthDate', row.yearMonthDate)
      this.title = '新增资金计划周期'
      this.dialogWeekVisible = true

      // 设置日期限制规则（新增时没有开始日期初始值）
      this.setDatePickerOptions(row.yearMonthDate, null)
    },
    editWeekFn (row) {
      this.title = '修改资金计划周期'
      this.$set(this.addWeekForm, 'cycleMasterId', row.cycleMasterId)
      this.$set(this.addWeekForm, 'cycleDetailId', row.cycleDetailId)
      this.$set(this.addWeekForm, 'startMonth', row.startMonth)
      this.$set(this.addWeekForm, 'endMonth', row.endMonth)
      this.$set(this.addWeekForm, 'cycleName', row.cycleName)
      this.$set(this.addWeekForm, 'weekSubmitPlanDate', this.dateFormat(row.weekSubmitPlanDate))
      // 保存当前编辑行的年月
      this.$set(this.addWeekForm, 'yearMonthDate', row.yearMonthDate)
      this.dialogWeekVisible = true
      this.isAddWeek = false

      // 设置日期限制规则
      this.setDatePickerOptions(row.yearMonthDate, row.startMonth)
    },
    // 新增方法：统一设置日期选择器限制规则
    setDatePickerOptions (yearMonth, startDateValue) {
      if (!yearMonth) return

      const [year, month] = yearMonth.split('-')
      // 获取月份的第一天（00:00:00）
      const monthStart = new Date(parseInt(year), parseInt(month) - 1, 1, 0, 0, 0)
      // 获取月份的最后一天（23:59:59）
      const monthEnd = new Date(parseInt(year), parseInt(month), 0, 23, 59, 59)

      // 开始日期的限制：只能在当前月份内
      this.startDatePickerOptions = {
        disabledDate: (time) => {
          const targetDate = new Date(time.getTime())
          targetDate.setHours(0, 0, 0, 0)
          const start = new Date(monthStart.getTime())
          start.setHours(0, 0, 0, 0)
          const end = new Date(monthEnd.getTime())
          end.setHours(0, 0, 0, 0)
          return targetDate < start || targetDate > end
        }
      }

      // 结束日期的限制规则（会根据开始日期动态变化）
      this.updateEndDatePickerOptions(yearMonth)
    },
    // 新增方法：更新结束日期限制规则
    updateEndDatePickerOptions (yearMonth) {
      if (!yearMonth) return

      const [year, month] = yearMonth.split('-')
      const monthStart = new Date(parseInt(year), parseInt(month) - 1, 1, 0, 0, 0)
      const monthEnd = new Date(parseInt(year), parseInt(month), 0, 23, 59, 59)

      this.editEndDatePickerOptions = {
        disabledDate: (time) => {
          const targetDate = new Date(time.getTime())
          targetDate.setHours(0, 0, 0, 0)

          // 1. 不能跨月：必须在当前月份内
          const start = new Date(monthStart.getTime())
          start.setHours(0, 0, 0, 0)
          const end = new Date(monthEnd.getTime())
          end.setHours(0, 0, 0, 0)
          const isOutOfMonth = targetDate < start || targetDate > end

          // 2. 不能小于开始日期
          let isBeforeStart = false
          if (this.addWeekForm.startMonth) {
            const startDate = new Date(this.addWeekForm.startMonth)
            startDate.setHours(0, 0, 0, 0)
            isBeforeStart = targetDate < startDate
          }

          return isOutOfMonth || isBeforeStart
        }
      }
    },
    saveWeekFn () {
      this.$refs.addWeekForm.validate(valid => {
        if (valid) {
          // 统一校验函数
          const validateDates = () => {
            const yearMonth = this.addWeekForm.yearMonthDate
            if (!yearMonth) {
              this.$message.error('年月信息缺失')
              return false
            }

            const [year, month] = yearMonth.split('-')
            const startDate = new Date(this.addWeekForm.startMonth)
            const endDate = new Date(this.addWeekForm.endMonth)

            // 重置时间部分，只比较日期
            startDate.setHours(0, 0, 0, 0)
            endDate.setHours(0, 0, 0, 0)

            // 获取月份的第一天和最后一天
            const monthFirstDay = new Date(parseInt(year), parseInt(month) - 1, 1)
            monthFirstDay.setHours(0, 0, 0, 0)
            const monthLastDay = new Date(parseInt(year), parseInt(month), 0)
            monthLastDay.setHours(0, 0, 0, 0)

            // 校验开始日期是否跨月
            if (startDate < monthFirstDay || startDate > monthLastDay) {
              this.$message.error(`开始日期必须在${year}-${month}月份内`)
              return false
            }

            // 校验结束日期是否跨月
            if (endDate < monthFirstDay || endDate > monthLastDay) {
              this.$message.error(`结束日期必须在${year}-${month}月份内`)
              return false
            }

            // 校验结束日期不能小于开始日期
            if (endDate < startDate) {
              this.$message.error('结束日期不能小于开始日期')
              return false
            }

            return true
          }

          if (!validateDates()) {
            return
          }
          if (this.isAddWeek) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            saveFundPlanCycleWeek(this.addWeekForm)
              .then(res => {
                console.log(res)
                loading.close()
                this.dialogWeekVisible = false
                this.findFundPlanCycleList()
                this.initAddForm()
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
              })
              .catch(err => {
                console.log(err)
                this.$message({
                  showClose: true,
                  message: err.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            updateFundPlanCycle(this.addWeekForm)
              .then(res => {
                console.log(res)
                loading.close()
                this.dialogWeekVisible = false
                this.findFundPlanCycleList()
                this.initAddForm()
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
              })
              .catch(err => {
                console.log(err)
                this.$message({
                  showClose: true,
                  message: err.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
          }
        } else {
        }
      })
    },
    updateMonthFn (row) {
      this.title = '修改月提交计划日期'
      this.$set(this.updateMonthForm, 'cycleMasterId', row.cycleMasterId)
      this.$set(this.updateMonthForm, 'monthSubmitPlanDate', this.dateFormat(row.monthSubmitPlanDate))
      this.updateMonthVisible = true
    },
    closeUpdateMonth () {
      this.updateMonthVisible = false
      this.initAddForm()
    },
    saveUpdateMonthFn () {
      this.$refs.updateMonthForm.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          updateMonthSubmitPlan(this.updateMonthForm)
            .then(res => {
              console.log(res)
              loading.close()
              this.updateMonthVisible = false
              this.findFundPlanCycleList()
              this.initAddForm()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
            })
            .catch(err => {
              console.log(err)
              this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        } else {
        }
      })
    },
    // 时间格式化
    dateFormat: function (cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
    }
  }
}
</script>

<style scoped lang="less">
.searchBtnBox {
  margin-left: 10px;
}
.addinpBox .el-input {
  width: 210px;
}
.demo-form-inline .el-select {
  width: 210px;
}
/deep/.el-input.is-disabled .el-input__inner{
  color: #333 !important;
}
</style>
